import React, { useEffect, useState } from "react";
import { getListOfInvoices } from "../subscription-service";
import dayjs from "dayjs";
import InvoicePaymentModal from "./invoicePaymentModal";
import ChevronsRightIcon from "../../../shared-components/icons/ChevronsRightIcon";
import { useAppDispatch } from "../../../redux/hooks";
import { publishModalData, publishModalProps, publishModalVisibility } from "../../../redux/features/modal/modalSlice";
import { useSubscriptionContext } from "../subscriptionContext";
import PaymentProcessingModal from "../InvoiceProcessingModal";

const PAST_DUE_STATUSES: string[] = ["open"];

const PastDueInvoicesList = () => {
  const { isInvoiceProcessing } = useSubscriptionContext();
  const dispatch = useAppDispatch();
  const [invoicesList, setInvoicesList] = useState<Invoice[]>([]);
  const [isInvoicesLoading, setIsInvoicesLoading] = useState<boolean>(true);
  useEffect(() => {
    getListOfInvoices()
      .then(res => res.json())
      .then((res: InvoiceList) => {
        if (res.data) {
          setInvoicesList(res.data.filter(invoice => PAST_DUE_STATUSES.includes(invoice.status)));
        }
        setIsInvoicesLoading(false);
      })
      .catch(err => console.error(err));
  }, []);

  const onClickInvoice = (id: string) => {
    dispatch(
      publishModalData({
        modalData: <InvoicePaymentModal invoiceId={id} />,
      })
    );
    dispatch(publishModalProps({ withOverlay: false }));
    dispatch(publishModalVisibility({ isOpen: true }));
  };

  if (invoicesList.length === 0) {
    return null;
  }

  return (
    <div>
      <div data-name={"in-play-prizes"} className={`border border-b-black/8 p-3 lg:py-4 lg:px-8 rounded-lg`}>
        <div
          className={"mb-3 lg:mb-4 text-secondary font-jost text-sm font-medium leading-5 lg:text-xl lg:leading-6.5"}>
          Past due invoices
        </div>
        <div className={"w-full h-px bg-black/8 mb-1.5 lg:mb-2"} />

        <div className={"table table-fixed w-full border-collapse"}>
          {invoicesList.map(invoice => (
            <>
              <div key={invoice.id} className={"table-row"}>
                <div
                  className={
                    "table-cell w-[25%] lg:w-[15%] text-left align-middle py-1.5 lg:py-2 pr-1 text-secondary text-xs font-medium leading-4 lg:text-base lg:leading-5.5"
                  }>
                  {dayjs(invoice.effective_at * 1000).format("DD MMM YYYY")}
                </div>
                <div
                  className={
                    "table-cell w-[20%] lg:w-[15%] text-center align-middle px-1 py-1.5 lg:py-2 text-secondary text-xs font-medium leading-4 lg:text-base lg:leading-5.5"
                  }>
                  £{invoice.amount_due / 100}
                </div>
                <div className={"table-cell w-[25%] lg:w-[25%] text-center align-middle px-1 py-1.5 lg:py-2"}>
                  <div className="inline-flex items-center font-jost uppercase text-xs leading-3.5 rounded min-h-4.5 lg:min-h-6.5 px-1.5 lg:px-2 py-0.5 text-red-5 font-medium bg-red-3 border border-red-6 lg:text-[13px] lg:leading-4.5">
                    Past Due
                  </div>
                </div>
                <div className={"table-cell w-[30%] lg:w-[45%] text-right align-middle pl-1 py-1.5 lg:py-2"}>
                  <button
                    onClick={() => onClickInvoice(invoice.id)}
                    className={"theme-btn theme-btn-primary theme-btn-3xs lg:theme-btn-2sm lg:min-w-[139px] uppercase"}>
                    Pay now
                    <ChevronsRightIcon variant={2} className={"size-4 shrink-0 max-lg:hidden"} />
                  </button>
                </div>
              </div>
            </>
          ))}
        </div>
      </div>

      {isInvoiceProcessing && <PaymentProcessingModal />}
    </div>
  );
};

export default PastDueInvoicesList;
